export default function OrderBy() {
  this.data = {
    column: null,
    direction: 'asc' // asc | desc
  };

  /*
 * Set column that need to be sorted.
 */
  this.setColumn = function (column) {
    if (this.data.column === column) {
      // toggle asc <-> desc
      this.data.direction = this.data.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.data.column = column;
      this.data.direction = 'asc';
    }
  };

  /*
   * Get class asc or desc based on column name.
   */
  this.getClass = function(column) {
    if (this.data.column === column) {
      return this.data.direction;
    }
    return '';
  };

  /*
   * Return format for API
   * { order_by: 'name', sort_by: 'asc' }
   */
  this.toQuery = function() {
    if (!this.data.column) return null;

    return {
      order_by: this.data.column,
      sort_by: this.data.direction
    };
  };

  /*
   * Reset from query object
   * Accept:
   *   { order_by: 'name', sort_by: 'asc' }
   */
  this.reset = function(query) {
    this.data.column = null;
    this.data.direction = 'asc';

    if (!query) return;

    if (typeof query === 'object') {
      if (query.order_by && query.sort_by) {
        this.data.column = query.order_by;
        this.data.direction = query.sort_by === 'desc' ? 'desc' : 'asc';
      }
    }

    // optional: backward compatibility
    if (typeof query === 'string') {
      const parts = query.split(',');
      this.data.column = parts[0];
      this.data.direction = parts[1] === 'desc' ? 'desc' : 'asc';
    }
  };
}